import { Box, Checkbox, List, ListItemText, MenuItem, Select, Typography } from "@mui/material";
import { useConfigListUsers } from "../../../hooks/config-page";
import { UserType } from "../../../hooks/config-page/user.type";

export default function StoreManagerSelector({
  value = [],
  onChange,
  disabled
}: {
  disabled?: boolean,
  value?: string[],
  onChange?: (value: UserType[]) => void
}) {
  const { data: dataUsers } = useConfigListUsers()
  const listUsers = dataUsers?.users || []

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', mt: 1, gap: '6px', }}>
      <Typography sx={{ flex: 'none' }}>Select Users to Notify: </Typography>
      <Select
        size='small'
        multiple
        value={value}
        disabled={disabled}
        renderValue={(selected) => {
          const selectedUsers = listUsers.filter((item) => selected.includes(item.uuid))
          return selectedUsers.map((item) => item.username).join(', ')
        }}
        onChange={(e) => {
          const selectedValues = e.target.value as string[]
          onChange?.(listUsers.filter((item) => selectedValues.includes(item.uuid)))          
        }}
        // onChange={(e) => setSelectedMap(optionMaps.find((item) => item.map_uuid === e.target.value) || undefined)}
        sx={{ width: '100%', flex: 'auto', minWidth: '200px' }}
      >
        {listUsers.map((item, index) => (
          <MenuItem
            key={index}
            value={item.uuid}
          >
            <Checkbox checked={value.includes(item.uuid)} />
            <ListItemText primary={item.username} secondary={item.email} />
          </MenuItem>
        ))}
      </Select>
    </Box>
  )
}